import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  activity_logs: [],
};

const getters = {
  allActivityLogs: (state) => state.activity_logs,
};

const actions = {
  async fetchActivityLogs({ commit }, params = {}) {
    try {
      commit("resetActivityLogs");
      const response = await axios.get("/activity-log", { params: prm(params) });
      commit("setActivityLogs", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch activity logs:", error);
    }
  },
  async createActivityLog({ commit }, activity_log) {
    try {
      const response = await axios.post("/activity-log", activity_log);
      commit("addActivityLog", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create activity log:", error);
      throw error;
    }
  },
  async fetchActivityLogById(_, id) {
    try {
      const response = await axios.get(`/activity-log/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch activity log:", error);
      throw error;
    }
  },
  async updateActivityLog({ commit }, activity_log) {
    try {
      const response = await axios.put(`/activity-log/${activity_log.id}`, activity_log);
      commit("updateActivityLog", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to update activity log:", error);
      throw error;
    }
  },
  async updateActivityLogStatus({ commit }, { activity_log, newStatus }) {
    try {
      const updatedActivityLog = {
        ...activity_log,
        is_active: newStatus
      };
      const response = await axios.put(`/activity-log/${activity_log.id}`, updatedActivityLog);
      commit("updateActivityLog", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to update activity log status:", error);
      throw error;
    }
  },
  async deleteActivityLogById({ commit }, id) {
    try {
      const response = await axios.delete(`/activity-log/${id}`);
      commit("removeActivityLog", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete activity log:", error);
      throw error;
    }
  },
};

const mutations = {
  setActivityLogs(state, activity_logs) {
    state.activity_logs = activity_logs.data;
  },
  addActivityLog(state, activity_log) {
    state.activity_logs.push(activity_log);
  },
  updateActivityLog(state, updatedActivityLog) {
    const index = state.activity_logs.findIndex(
      (item) => item.id === updatedActivityLog.id
    );
    if (index !== -1) {
      state.activity_logs.splice(index, 1, updatedActivityLog);
    }
  },
  removeActivityLog(state, id) {
    state.activity_logs = state.activity_logs.filter(
      (item) => item.id !== id
    );
  },
  resetActivityLogs(state) {
    state.activity_logs = {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
